import {
  Accordion,
  AccordionBody,
  AccordionHeading,
  AccordionItem,
  AccordionTitle,
  ButtonIcon,
  Col,
  DataTable,
  Grid,
  Icon,
  Link,
  Listbox,
  ListboxItem,
  ListboxItemContainer,
  Nav,
  NavLinks,
  Navmenu,
  NavSite,
  Row,
  Tab,
  TabItem,
  TabList,
  Tbody,
  Td,
  Th,
  Tr,
  Typography,
} from "@visa/vds";
import MCSGridRevert from "../../components/MCSGridRevert";
import React, { useState } from "react";
import "./VsttAbout.css";
import VSTTPage5 from "../../_imgs/vstt/VSTTPage-5.png";
import VSTTPage6 from "../../_imgs/vstt/VSTTPage-6.png";
import VSTTPage9 from "../../_imgs/vstt/VSTTPage-9.png";
import VSTTPage13 from "../../_imgs/vstt/VSTTPage-13.png";
import VSTTPage17 from "../../_imgs/vstt/VSTTPage-17.png";
import { WHATISVSTT, VSTTTESTMERCHANT, VSTTTESTACS, BEFOREYOUBEGIN, HOWTOENROLL, VSTTRESOURCES, SUBSCRIBING_VSTT_GUIDE } from "../../_constants/PageRoutes";
import { useHistory } from "react-router-dom";
import { ListItems, Steps, TableItems, whatIsVSTTText, merchantSimulatorText, acsText, StepsVertical } from "_constants/VsttConstants";
import { VsttAboutHorizontalTable, VsttAboutVerticalTable } from "./Components/DataTablesVerticalHorizontalSwitch";

function VsttAbout() {
  const history = useHistory();
  const clickHandler = () => history.push(SUBSCRIBING_VSTT_GUIDE);
  const [selectedTab, setSelectedTab] = useState(0);
  const [selectedTabACSAccordion, setSelectedTabACSAccordion] = useState(0);
  const [selectedTabMAccordion, setSelectedTabMAccordion] = useState(0);
  const defaultACSAccordion = [selectedTabACSAccordion];
  const defaultMAccordion = [selectedTabMAccordion];
  const vsttTabs = [
    { name: 'What is VSTT?', link: WHATISVSTT },
    { name: 'Merchant Simulator', link: VSTTTESTMERCHANT },
    { name: 'ACS Simulator', link: VSTTTESTACS },
    { name: 'Before you begin...', link: BEFOREYOUBEGIN },
    { name: 'How to Enroll', link: HOWTOENROLL },
    { name: 'Resources', link: VSTTRESOURCES }
  ];
  return (
    <>
      <Nav type={"blue"} selectedTab={selectedTab} setSelectedTab={setSelectedTab} className="vstt-about-secondary-header-nav">
        <Grid>
          <Row>
            <nav className="col">
              <NavSite align={"left"}>
                <NavLinks className="vstt-about-nav-list">
                  <TabList role="list" selectedTab={selectedTab} className="vstt-about-nav-tab-list">
                    {
                      vsttTabs.map((tab, index) => (
                        <TabItem key={index} className="vstt-about-nav-tab-list">
                          <Tab onClick={() => setSelectedTab(index)} tag={<a />} href={tab.link} role={undefined} className="vstt-about-nav-tab-list">
                            <b className={selectedTab === index ? 'vstt-about-selected-navbar-tab' : 'vstt-about-nav-site-padding'}>{tab.name}</b>
                          </Tab>
                        </TabItem>
                      ))
                    }
                  </TabList>
                </NavLinks>
              </NavSite>
            </nav>
          </Row>
        </Grid>
      </Nav>
      <MCSGridRevert>
        <Row id="WhatIsVSTT?" className="vstt-about-breaking-rows-start"/>
        <Row>
          <Col className="vstt-about-static-header">
            <Typography tag="h1" variant="headline" >
              Visa Secure Test Tools
            </Typography>
          </Col>
        </Row>
        <Row >
          <Col xs={8} sm={8} md={8} lg={6} xl={6} className="vstt-about-static-header">
            <Typography tag="h1" variant="headline">
              <div className="vstt-about-bolded-blue-text padding-bottom-10px">What is VSTT?</div>
            </Typography>
            <Typography variant="body" className="vss-text-body-large" >
              <div className="vss-text-body-large"><b>Visa Secure Test Tools (VSTT) </b>{whatIsVSTTText}</div>
            </Typography>
          </Col>          
          <Col xs={4} md={8} lg={6} xl={6} className="vstt-about-image-block">
            <Row className="vstt-about-breaking-rows-1"/>
            <Row>
              <div className="vstt-about-vss-ilustration-image-panel2">
                <img src={VSTTPage5} alt="VSTT Test Merchant simulator"/>
              </div>
            </Row>
            <div id="VSTTTestMerchant"></div>
            <Row>
              <div className="vstt-about-vss-ilustration-image-panel2">
                <img src={VSTTPage6} alt="VSTT Test ACS simulator"/>
              </div>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col xs={4} md={8} lg={6} xl={6} className="vstt-about-visa-secure-text-description-double-col">
            <Row className="vstt-about-static-header" >
              <Typography tag="h1" variant="headline">
                <div className="vstt-about-bolded-blue-text">Merchant Simulator</div>
              </Typography>
            </Row>
            <Row >
              <Typography variant="body" className="vss-text-body-large">
                <div className="vss-text-body-large padding-top-10px" >{merchantSimulatorText}</div>
              </Typography>
              <br/><br/>
            </Row>
            <Row className="vstt-about-breaking-rows-between"/>
            <Row className="display-flex justify-content-flex-start">
              <div className="vstt-about-vss-ilustration-image-panel2">
                <img src={VSTTPage9} alt="Merchant Simulator"/>
              </div>
            </Row>
            <Row id="VSTTTestACS"/>
          </Col>
          <Col xs={6} md={8} lg={6} xl={6}>
            <Row className="vstt-about-breaking-rows"/>
            <Row>
              <Col>
                <Typography variant="body" className="vss-text-body-large"><b>With VSTT Test Merchant, issuers and ACS providers can test...</b></Typography>
                <Accordion id="accordion-test-id" defaultExpandedId={defaultMAccordion}>
                  <AccordionItem>
                    <AccordionHeading className="vstt-about-accordion-rows">
                      <AccordionTitle className="vstt-about-vss-custom-header">ACS Implementations</AccordionTitle>
                    </AccordionHeading>
                    <AccordionBody>
                      <Typography variant="body" className="vstt-about-vss-custom-header">
                      Review the various EMV 3DS (Directory Server) use cases and how the ACS responds prior to launching in production. Testing ACS implementation allows for early detection and resolution of issues, ensuring optimal performance, and security.
                      </Typography>
                    </AccordionBody>
                  </AccordionItem>
                  <AccordionItem>
                    <AccordionHeading className="vstt-about-accordion-rows">
                      <AccordionTitle className="vstt-about-vss-custom-header">Authentication Strategies</AccordionTitle>
                    </AccordionHeading>
                    <AccordionBody>
                      <Typography variant="body" className="vstt-about-vss-custom-header">
                      Solidify authentication and fraud management strategies by testing various authentication methods and ACS rules.
                      </Typography>
                    </AccordionBody>
                  </AccordionItem>
                  <AccordionItem>
                    <AccordionHeading className="vstt-about-accordion-rows">
                      <AccordionTitle className="vstt-about-vss-custom-header">Ongoing Performance Validation</AccordionTitle>
                    </AccordionHeading>
                    <AccordionBody>
                      <Typography variant="body" className="vstt-about-vss-custom-header">
                      Validate the performance and usage of different authentication methods, electronic commerce indicators (ECI), 
                      and cardholder authentication verification values (CAVV) in the Visa Secure flows.
                      </Typography>
                    </AccordionBody>
                  </AccordionItem>
                  <AccordionItem>
                    <AccordionHeading className="vstt-about-accordion-rows">
                      <AccordionTitle className="vstt-about-vss-custom-header">User Experience</AccordionTitle>
                    </AccordionHeading>
                    <AccordionBody>
                      <Typography variant="body" className="vstt-about-vss-custom-header">
                      Ensure that the user experience is seamless and meets expectations.
                      </Typography>
                    </AccordionBody>
                  </AccordionItem>
                </Accordion>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col xs={4} md={8} lg={6} xl={6} className="vstt-about-visa-secure-text-description-double-col">
            <Row className="vstt-about-static-header">
              <Typography tag="h1" variant="headline">
                <div className="vstt-about-bolded-blue-text">ACS Simulator</div>
              </Typography>
            </Row>
            <Row className="vstt-about-helper-acs">
              <Typography variant="body" className="vss-text-body-large">
                <div className="vss-text-body-large padding-top-10px">{acsText}</div>
              </Typography>
              <br/><br/>
            </Row>
            <Row className="vstt-about-breaking-rows-between"/>
            <Row className="display-flex justify-content-flex-start">
              <div className="vstt-about-vss-ilustration-image-panel2">
                <img src={VSTTPage13} alt="ACS Simulator"/>
              </div>
            </Row>
            <div id="BeforeYouBegin"></div>
          </Col>
          <Col xs={6} md={8} lg={6} xl={6}>
            <Row>
              <Col>
                <Row className="vstt-about-breaking-rows"/>
                <Typography variant="body" className="vss-text-body-large"><b>With VSTT Test ACS, merchants and 3DSS providers can test...</b></Typography>
                <Accordion id="accordion-test-id-2" defaultExpandedId={defaultACSAccordion}>
                  <AccordionItem>
                    <AccordionHeading className="vstt-about-accordion-rows">
                      <AccordionTitle className="vstt-about-vss-custom-header">3DSS Implementations</AccordionTitle>
                    </AccordionHeading>
                    <AccordionBody>
                      <Typography variant="body" className="vstt-about-vss-custom-header">
                      Review the various EMV 3DS (Directory Server) use cases and how the 3DS (Directory Server) responds prior to launching in production. Testing 3DSS implementation allows for early detection and resolution of issues, ensuring optimal performance, and security. 
                      </Typography>
                    </AccordionBody>
                  </AccordionItem>
                  <AccordionItem>
                    <AccordionHeading className="vstt-about-accordion-rows">
                      <AccordionTitle className="vstt-about-vss-custom-header">Transaction Testing</AccordionTitle>
                    </AccordionHeading>
                    <AccordionBody>
                      <Typography variant="body" className="vstt-about-vss-custom-header">
                      Test for different ACS responses based on transaction type using a real ACS and the Directory Server.
                      </Typography>
                    </AccordionBody>
                  </AccordionItem>
                  <AccordionItem>
                    <AccordionHeading className="vstt-about-accordion-rows">
                      <AccordionTitle className="vstt-about-vss-custom-header">Ongoing Performance Validation</AccordionTitle>
                    </AccordionHeading>
                    <AccordionBody>
                      <Typography variant="body" className="vstt-about-vss-custom-header">
                      Validate the performance and usage of different authentication methods, electronic commerce indicators (ECI), and cardholder authentication verification values (CAVV) in the Visa Secure flows.
                      </Typography>
                    </AccordionBody>
                  </AccordionItem>
                  <AccordionItem>
                    <AccordionHeading className="vstt-about-accordion-rows">
                      <AccordionTitle className="vstt-about-vss-custom-header">User Experience</AccordionTitle>
                    </AccordionHeading>
                    <AccordionBody>
                      <Typography variant="body" className="vstt-about-vss-custom-header">
                      Ensure that the user experience is seamless and meets expectations.
                      </Typography>
                    </AccordionBody>
                  </AccordionItem>
                </Accordion>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="display-flex justify-content-center">
          <Col xs={9} md={9} lg={9} xl={9} className="vstt-about-visa-secure-text-description">
            <Row className="vstt-about-static-header">
              <Typography tag="h1" variant="headline" className="padding-bottom-10px">
                <div className="vstt-about-bolded-blue-text">Before you begin...</div>
              </Typography>
            </Row>
            <Row>
              {ListItems.map((listitem)=>(
                <Typography variant="body" className="vss-text-body-large">
                <b className="vstt-about-bolded-blue-text">{listitem.pre}</b> {listitem.content} 
                </Typography>
              ))}
            </Row>
          </Col>
          <Col xs={3} md={3} lg={3} xl={3}>
            <Row className="display-flex justify-content-flex-start">
              <div className="vstt-about-vss-ilustration-image-panel2">
                <img src={VSTTPage17} className="vstt-about-sprite-illustration"/>
              </div>
            </Row>
          </Col>
        </Row>
        <Row>
          <Row className="padding-left-10px">
            <Typography tag="h1" variant="headline" id="HowToEnroll?">
              <div className="vstt-about-bolded-blue-text padding-bottom-10px">How to Enroll</div>
            </Typography>
          </Row>
          <Col>
            <VsttAboutHorizontalTable Steps={Steps} TableItems={TableItems} />
            <VsttAboutVerticalTable StepsVertical={StepsVertical} />
          </Col>
        </Row>
        <Row>
          <Col xs={4} md={12} lg={12} xl={12} id="Resources">
            <Typography tag="h1" variant="headline">
              <div className="vstt-about-bolded-blue-text" >Resources</div>
            </Typography>
            <Typography className="vstt-about-vss-learn-more">
              Review the{" "}
              <Link
                id="gettingStartedGuideLink"
                onClick={clickHandler}
                inline
                className="vstt-about-vss-link"
                aria-label="Getting Started Guide"
              >
              Subscribing to VSTT Guide and the VSTT Merchant Supported Test Cases {" "} 
              </Link>
              in the Visa Secure Services Library. Sign in to access additional resources.
            </Typography>
          </Col>
        </Row>
        <Row className="vstt-about-breaking-rows"/>
      </MCSGridRevert>
    </>
  );
}

export default VsttAbout;
